import pickBy from 'lodash/pickBy'
import some from 'lodash/some'
import identity from 'lodash/identity'
import mapValues from 'lodash/mapValues'

const filterEmptyQuotas = form => {
  // Filter out quotas with empty limit
  form.quotas = pickBy(form.quotas, val => !!val.limit)
}

const validAge = ({ high, low }) => low && high && high >= low

export const formToRequestData = form => {
  const data = JSON.parse(JSON.stringify(form)) // Copy
  filterEmptyQuotas(data)
  return data
}

export const isQuestionsValid = questions =>
  !some(
    questions,
    (value, key) =>
      key === 'age'
        ? some(value, ageObj => !validAge(ageObj)) // Invalid/empty age range
        : value.length === 0 // No answers selected
  )

export const fieldErrors = values => {
  const errors = {
    completions: val => !val && 'Please provide the number of participants.',
    interviewLength: val =>
      !val && 'Please provide the length of the interview.',
    fieldLength: val => !val && 'Please provide the field duration.',
    incidence: val => {
      if (!val) {
        return 'Please provide the incidence rate.'
      } else if (val > 100) {
        return 'Please provide a number less than or equal to 100%.'
      }
      return false
    },
    pii: val => val === null && 'Please select an option.',
    locale: val => !val && 'Please select an option.'
  }

  return pickBy(mapValues(errors, (errFn, key) => errFn(values[key])), identity)
}



// WEBPACK FOOTER //
// ./src/utils/form.js